import type { ReactNode } from 'react';

interface MarquePassageProps {
  children: ReactNode;
}

/**
 * A passage a "Bloquant" point of an indicator other than the additions is about (A8), in the
 * translated text of "Texte traduit": a `gray-200` background and a 2 px `gray-700` line under it.
 * Red is the colour of the additions only (decision of 2026-10-13, #30, and its extension to
 * "Texte traduit", #35): a blocking passage that was `rouge-tint` with a `rouge-deep` line would read
 * as an addition. The line and the legend say it, not the colour alone; black on `gray-200` and
 * the line on it pass AA (`tests/contrastes.test.ts`). Not focusable: it has no bubble, its card
 * says what Tahiti says of it.
 */
export function MarquePassage({ children }: MarquePassageProps) {
  return (
    <mark className="rounded-sm border-gray-700 border-b-2 bg-gray-100 px-1 text-inherit">
      {children}
    </mark>
  );
}
